import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {
  setJobPaymentRefundTransactionId,
  setJobPaymentRefundTransactionStatus, setJobPaymentStatus,
  setJobPaymentStep
} from "./jobPaymentActions";
import {PAYMENT_STEPS, TRANSACTION_STATUSES} from "./jobPaymentReducer";
import {postACHPayment} from "./jobPaymentAsyncActions";


const JobPaymentPopupFooterButtons = (props) => {

  const {setJobPaymentStep, paymentStep, closePopup, refundTransactionId, setJobPaymentRefundTransactionId,
    refundTransactionStatus, setJobPaymentRefundTransactionStatus, paymentStatus, setJobPaymentStatus,
    postACHPayment} = props;

  const [loading, setLoading] = useState(false);

  const isFirstStep = paymentStep === 0;
  const isPaymentStep = paymentStep === PAYMENT_STEPS.adjustPrice;
  const isLastStep = paymentStep === PAYMENT_STEPS.finalPage;
  const isTransactionsStep = paymentStep === PAYMENT_STEPS.transactions;

  const isPaymentError = paymentStatus && paymentStatus.status === TRANSACTION_STATUSES.Error;

  const prevClick = () => {
    if (refundTransactionId) {
      setJobPaymentRefundTransactionId("");
      setJobPaymentRefundTransactionStatus("");
      return;
    }
    if (isFirstStep) {
      closePopup();
      return
    }
    if (isLastStep) {
      setJobPaymentStep(PAYMENT_STEPS.transactions);
      return;
    }
    setJobPaymentStep(paymentStep - 1)
  }

  const nextClick = async () => {
    if (isPaymentStep) {
      setLoading(true);
      await postACHPayment()
      setLoading(false);
    }
    if (isPaymentError) {
      setJobPaymentStep(PAYMENT_STEPS.payments);
      setJobPaymentStatus(null); // clear
      return;
    }
    if (refundTransactionId) {
      if (refundTransactionStatus) {
        setJobPaymentRefundTransactionId("");
        setJobPaymentRefundTransactionStatus("");
        setJobPaymentStep(PAYMENT_STEPS.transactions);
        return;
      }
      setJobPaymentRefundTransactionStatus("success");
      return;
    }
    if (isLastStep || isTransactionsStep) {
      closePopup();
      return
    }
    setJobPaymentStep(paymentStep + 1)
  }

  const prevDisabled = false; // add validation
  const nextDisabled = false; // add validation

  if (isTransactionsStep) {
    return (
      <div className="ui-popup-footer job-payment__container">
        {refundTransactionId && !refundTransactionStatus ? (
          <button className={"ui-button5 ui-button5--small ui-button5--145 ui-button5--black-border"}
                  onClick={prevClick}>
            <FormattedMessage id="messageBox.buttons.back"/>
          </button>
        ) : null}
        <button className={"ui-button5 ui-button5--small ui-button5--black"
          + (refundTransactionStatus ? "" : " ui-button5--145")}
                onClick={nextClick}
                disabled={nextDisabled}>
          <FormattedMessage id={
            refundTransactionStatus
              ? "paymentPopup.viewTransactions"
              : refundTransactionId
                ? "paymentPopup.refund.button"
                : "messageBox.buttons.close"
          }/>
        </button>
      </div>
    )
  }

  return (
    <div className="ui-popup-footer job-payment__container">
      {isPaymentError ? null : (
        <button className={"ui-button5 ui-button5--small "
          + (isLastStep ? "ui-button5--black" : "ui-button5--145 ui-button5--black-border")}
                onClick={prevClick}
                disabled={prevDisabled}>
          <FormattedMessage id={isLastStep ? "paymentPopup.viewTransactions" : "messageBox.buttons.back"}/>
        </button>
      )}
      <button className={"ui-button5 ui-button5--small "
        + (isPaymentStep ? "ui-button5--green" : "ui-button5--black")
        + (isPaymentError ? "" : " ui-button5--145")}
              onClick={loading ? null : nextClick}
              disabled={nextDisabled}>
        {loading ? <div className="ui-loader ui-loader--white ui-loader--auto"/> : <FormattedMessage id={
          isPaymentError
            ? "paymentPopup.errorButton"
            : isPaymentStep
              ? "paymentPopup.payButton"
              : isLastStep ? "messageBox.buttons.close" : "messageBox.buttons.next"
        }/>}
      </button>
    </div>
  )
};

JobPaymentPopupFooterButtons.propTypes = {
  closePopup: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {paymentStep, refundTransactionId, refundTransactionStatus, paymentStatus} = store.jobPaymentState;
  return {
    paymentStep,
    refundTransactionId,
    refundTransactionStatus,
    paymentStatus,
  };
};

const mapDispatchToProps = {
  setJobPaymentStep,
  setJobPaymentStatus,
  setJobPaymentRefundTransactionId,
  setJobPaymentRefundTransactionStatus,
  postACHPayment,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPaymentPopupFooterButtons)
)
